export default __webpack_public_path__ + "static/electrical_panel_b.d3371c2f63721d7eac4e8c925e9b3a03.png";